/** Snapping to the grid is personal (P16, backlog §19): remembered per board in this browser, never shared. */
const key = (boardId: string) => `os.snap.${boardId}`;

/** The stored choice for this board, or null when there is none (or storage is blocked). */
export function readStoredSnap(boardId: string): boolean | null {
  try {
    const v = localStorage.getItem(key(boardId));
    return v === '1' ? true : v === '0' ? false : null;
  } catch {
    return null;
  }
}

/** The stored choice for this board, else `fallback` (the board's own setting). */
export function readSnapPref(boardId: string, fallback: boolean): boolean {
  return readStoredSnap(boardId) ?? fallback;
}

export function writeSnapPref(boardId: string, on: boolean): void {
  try {
    localStorage.setItem(key(boardId), on ? '1' : '0');
  } catch {
    // Private mode or blocked storage: the choice lasts until the page is left.
  }
}
